<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import phil from "phil-reg-prov-mun-brgy";
import EmployeeModal from "@/components/modals/employee.vue";
import MaskedInput from "vue-text-mask";

export default {
  page: {
    title: "Delivery Units",
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    EmployeeModal,
    // MaskedInput
  },
  data() {
    return {
      title: "Delivery Units",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Delivery Units",
          active: true,
        },
      ],
      tableData: [],
      regionSelection: phil.regions,
      provinceSelection: [],
      citySelection: [],
      barangaySelection: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "item",
          sortable: true,
          label: "",
          thStyle: { width: "50px" },
        },
        {
          key: "campusName",
          sortable: true,
          label: `${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} Name`,
        },
        {
          key: "shortName",
          sortable: true,
          label: "Short Name",
        },
        {
          key: "location",
          sortable: true,
          label: "Location",
        },
        {
          key: "actions",
        },
      ],
      form: {
        id: 0,
        campusName: "",
        shortName: "",
        barangay: "",
        city: "",
        province: "",
        region: "",
        zipcode: "",
        signatory: "",
        position: "",
        fundsAvailableSignatory: "",
        fundsAvailablePosition: "",
        procurementSignatory: "",
        procurementSignatoryPosition: "",
        agencyId: this.$store.state.data.agency.id,
        inspectionHeadId: null,
        inspectionHeadName: "",
        prFundsAvailableSignatory: "",
        prFundsAvailablePosition: "",
        isExternal: false,
        useAllowPr: false,
        rfqCode: "",
        inspectionContactNumber: "",
        supplySignatoryId: null,
        district: '1',
        supplySignatory: { completeName: "" },
        propertyCustodian: { completeName: "" },
        supplySignatoryPosition: "",
        coaEmail: "",
        bacWebsite: '',
        opcrReviewedBy: '',
      },
      barangay: {},
      city: {},
      province: {},
      region: {},
      coaEmailUpdate: false,
      indexSelected: -1,
      tableBusy: false,
      selectedCampus: {},
      employeeSelection: "inspection",
      // office
      office: {
        id: 0,
        name: "",
        shortName: "",
        signatory: "",
        position: "",
        campusId: 0,
      },
      selectedOffice: {},

      // delivery Unit
      du: {
        id: 0,
        name: "",
        shortName: "",
        signatory: "",
        position: "",
        recommendingSignatory: "",
        recommendingPosition: "",
        rcCodeGf: "",
        rcCodeStf: "",
        officeId: 0,
        recommendingLabel: "",
        hideCampusSignatory: false,
        clusterId: ""
      },
      selectedDU: {},

      // department
      department: {
        id: 0,
        departmentName: "",
        shortName: "",
        deliveryUnitId: 0,
      },
      selectedChild: null,
      selectedParent: null,
      transfer: {
        campusId: 0,
        officeId: 0,
        duId: 0,
        type: 1,
      },
      offices: [],
      dus: [],
      clusters: [],
    };
  },
  validations: {
    form: {
      campusName: { required },
      shortName: { required },
      zipcode: { required },
    },
    office: {
      name: { required },
      shortName: { required },
    },
    du: {
      name: { required },
      shortName: { required },
    },
    department: {
      departmentName: { required },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    this.totalRows = this.items.length;
    this.tableBusy = true;
    this.$store
      .dispatch("campus/GetCampusByAgency", this.$store.state.data.agency.id)
      .then((res) => {
        res.data.forEach((item) => {
          item.location = `${item.barangay}, ${item.city}, ${item.province}, ${item.region}, ${item.zipcode}`;
          item.rotateChevy = false;
          item.offices = [];
          item.inspectionHeadName = item.inspectionHead
            ? item.inspectionHead.completeName
            : "";
        });
        this.tableData = res.data;
        this.tableBusy = false;
      })
      .catch(() => {
        this.showToast("Something went wrong!", "error");
        this.tableBusy = false;
      });
    this.getClusters();
  },
  methods: {
    getClusters(){
      this.clusters = [];
      this.$store.dispatch("cluster/GetCluster").then((res) => {
        if(res.data.error){
            return this.showToast(res.data.errorMessage, 'error');
        }
        res.data.map((item) => {
          this.clusters.push({
            text: item.clusterName,
            value: item.id
          });
        });
      })
      .catch(() => {
        this.showToast("Fetching Clusters went wrong!", 'error');
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addCampus() {
      this.onReset();
      this.modalTitle = `Create New ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`;
      this.$bvModal.show("modal-standard");
    },
    onCreate() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        if (this.form.id > 0) {
          var data = this.deepClone(this.form);
          this.$store
            .dispatch("campus/UpdateCampus", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (this.form.coaEmail != "") {
                this.submitEmailChanges();
              }
              data.location = `${data.barangay}, ${data.city}, ${data.province}, ${data.region}, ${data.zipcode}`;
              this.tableData.splice(this.indexSelected, 1, data);
              this.$bvModal.hide("modal-standard");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("campus/CreateCampus", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (this.form.coaEmail != "") {
                this.submitEmailChanges();
              }
              res.data.location = `${res.data.barangay}, ${res.data.city}, ${res.data.province}, ${res.data.region}, ${res.data.zipcode}`;
              this.tableData.push(res.data);
              this.$bvModal.hide("modal-standard");
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    onReset() {
      this.form = {
        id: 0,
        campusName: "",
        shortName: "",
        barangay: "",
        city: "",
        province: "",
        region: "",
        zipcode: "",
        signatory: "",
        position: "",
        fundsAvailableSignatory: "",
        fundsAvailablePosition: "",
        procurementSignatory: "",
        procurementSignatoryPosition: "",
        agencyId: this.$store.state.data.agency.id,
        inspectionHeadId: null,
        inspectionHeadName: "",
        prFundsAvailableSignatory: "",
        prFundsAvailablePosition: "",
        isExternal: false,
        useAllowPr: false,
        rfqCode: "",
        inspectionContactNumber: "",
        supplySignatoryId: null,
        supplySignatory: { completeName: "" },
        propertyCustodian: { completeName: "" },
        district: '1',
        supplySignatoryPosition: "",
        coaEmail: "",
      };
      this.city = "";
      this.barangay = "";
      this.shortName = "";
      this.region = "";
      this.province = "";
      this.coaEmailUpdate = false;
    },
    updateItem(props) {
      this.form = cloneDeep(props.item);
      this.form.supplySignatory = props.item.supplySignatory || {};
      this.form.propertyCustodian = props.item.propertyCustodian || {};
      this.indexSelected = this.tableData.indexOf(props.item);
      var regionSelected = phil.regions.find(
        (x) => x.name === props.item.region
      );
      this.region = regionSelected;
      this.getProvince(regionSelected);
      var provinceSelected = this.provinceSelection.find(
        (x) => x.name.toUpperCase() === props.item.province.toUpperCase()
      );
      this.province = provinceSelected;
      this.getCity(provinceSelected);
      var citySelected = this.citySelection.find(
        (x) => x.name.toUpperCase() === props.item.city.toUpperCase()
      );
      this.city = citySelected;
      this.getBarangays(citySelected);
      var barangaySelected = phil.barangays.find(
        (x) => x.name.toUpperCase() === props.item.barangay.toUpperCase()
      );
      this.barangay = barangaySelected;
      this.getCoaEmail(props.item.id);

      this.modalTitle = `Update ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`;
      this.$bvModal.show("modal-standard");
    },
    getCoaEmail(id) {
      this.$store.dispatch("coaemail/GetEmail", id).then((res) => {
        if (!res.data.error) {
          this.form.coaEmail = res.data;
          this.coaEmailUpdate = true;
          this.$forceUpdate();
        } else {
          this.coaEmailUpdate = false;
        }
      });
    },
    submitEmailChanges() {
      if (!this.coaEmailUpdate) {
        this.$store
          .dispatch("coaemail/CreateEmail", {
            email: this.form.coaEmail,
            campusId: this.form.id,
          })
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
          });
      } else {
        this.$store
          .dispatch("coaemail/UpdateEmail", {
            email: this.form.coaEmail,
            campusId: this.form.id,
          })
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
          });
      }
    },
    hideModal() {
      this.$bvModal.hide("modal-standard");
    },
    deleteItem(props) {
      var index = this.tableData.indexOf(props.item);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("campus/DeleteCampus", props.item.id)
            .then((res) => {
              if (res.status == 204) {
                this.tableData.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    getProvince(value) {
      if (!value) {
        return;
      }
      this.form.region = value.name;
      this.provinceSelection = phil.getProvincesByRegion(value.reg_code);
    },
    getCity(value) {
      if (!value) {
        return;
      }
      this.form.province = value.name;
      this.citySelection = phil.getCityMunByProvince(value.prov_code);
    },
    getBarangays(value) {
      if (!value) {
        return;
      }
      this.form.city = value.name;
      this.barangaySelection = phil.getBarangayByMun(value.mun_code);
    },
    getName(value) {
      this.form.barangay = value.name;
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.toggleDetails();
      if (row.item.rotateChevy) {
        this.getOffices(row.item);
      }
    },
    getOffices(row, modal) {
      this.$store
        .dispatch("office/GetOfficeByCampus", modal ? row : row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.showDtls = false;
            item.dus = [];
          });
          if (modal) {
            this.offices = res.data;
          } else {
            row.offices = res.data;
          }
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getDUs(row, modal) {
      if (!modal) {
        row.showDtls = !row.showDtls;
      }
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnitByOffice", modal ? row : row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.showDtls = false;
            item.departments = [];
          });
          if (modal) {
            this.dus = res.data;
          } else {
            row.dus = res.data;
          }
          this.tableBusy = false;
        })
        .catch(() => {
          this.showToast("Fetching DU went wrong!", "error");
          this.tableBusy = false;
        });
    },
    getDepartments(row) {
      row.showDtls = !row.showDtls;
      this.$store
        .dispatch("department/GetDepartmentByDU", row.id)
        .then((res) => {
          row.departments = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.showToast("Fetching DU went wrong!", "error");
          this.tableBusy = false;
        });
    },

    // offices
    addOffice(row) {
      this.selectedCampus = row;
      this.onResetOffice(row);
      this.modalTitle = "Create New Office";
      this.$bvModal.show("office-modal");
    },
    onCreateOffice() {
      this.submitted = true;
      this.$v.office.$touch();
      if (this.$v.office.$invalid) {
        return;
      } else {
        if (this.office.id > 0) {
          this.$store
            .dispatch("office/UpdateOffice", this.office)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.selectedCampus.offices.findIndex(
                (x) => x.id == this.office.id
              );
              res.data.showDtls = this.selectedCampus.offices[index].showDtls;
              res.data.dus = this.selectedCampus.offices[index].dus;
              this.selectedCampus.offices.splice(index, 1, res.data);
              this.$bvModal.hide("office-modal");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("office/CreateOffice", this.office)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              res.data.dus = [];
              res.data.showDtls = true;
              this.selectedCampus.offices.push(res.data);
              this.$bvModal.hide("office-modal");
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    onResetOffice(row) {
      this.office = {
        id: 0,
        name: "",
        shortName: "",
        signatory: "",
        position: "",
        campusId: row.id,
      };
    },
    updateOffice(props, row) {
      this.selectedCampus = row;
      this.office = cloneDeep(props);
      this.modalTitle = "Update Office";
      this.$bvModal.show("office-modal");
    },
    deleteOffice(props, row) {
      var index = row.offices.findIndex((item) => item.id == props.id);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("office/DeleteOffice", props.id)
            .then((res) => {
              if (res.status == 204) {
                row.offices.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },

    // Delivery Unit
    addDU(row) {
      this.selectedOffice = row;
      this.onResetDU(row);
      this.modalTitle = "Create New Delivery Unit";
      this.$bvModal.show("du-modal");
    },
    onCreateDU() {
      this.submitted = true;
      this.$v.du.$touch();
      if (this.$v.du.$invalid) {
        return;
      } else {
        if (this.du.id > 0) {
          this.$store
            .dispatch("deliveryunit/UpdateDeliveryUnit", this.du)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.selectedOffice.dus.findIndex(
                (item) => item.id == this.du.id
              );
              res.data.showDtls = this.selectedOffice.dus[index].showDtls;
              res.data.departments = this.selectedOffice.dus[index].departments;
              this.selectedOffice.dus.splice(index, 1, res.data);
              this.$bvModal.hide("du-modal");
              this.onReset();
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("deliveryunit/CreateDeliveryUnit", this.du)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              res.data.departments = [];
              res.data.showDtls = true;
              this.selectedOffice.dus.push(res.data);
              this.$bvModal.hide("du-modal");
              this.onReset();
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    onResetDU(row) {
      this.du = {
        id: 0,
        name: "",
        shortName: "",
        signatory: "",
        position: "",
        rcCodeGf: "",
        rcCodeStf: "",
        recommendingSignatory: "",
        recommendingPosition: "",
        officeId: row.id,
        recommendingLabel: "",
        hideCampusSignatory: false,
      };
    },
    updateDU(props, row) {
      this.selectedOffice = row;
      this.du = cloneDeep(props);
      this.modalTitle = "Update Delivery Unit";
      this.$bvModal.show("du-modal");
    },
    deleteDU(props, row) {
      let index = row.dus.findIndex((item) => item.id == props.id);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("deliveryunit/DeleteDeliveryUnit", props.id)
            .then((res) => {
              if (res.status == 204) {
                row.dus.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              } else {
                this.showToast("Something went wrong!", "error");
              }
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },

    // Department
    addDepartment(row) {
      this.selectedDU = row;
      this.onResetDepartment(row);
      this.modalTitle = "Create New Department";
      this.$bvModal.show("department-modal");
    },
    onCreateDepartment() {
      this.submitted = true;
      this.$v.department.$touch();
      if (this.$v.department.$invalid) {
        return;
      } else {
        if (this.department.id > 0) {
          this.$store
            .dispatch("department/UpdateDepartment", this.department)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.selectedDU.departments.findIndex(
                (item) => item.id == this.department.id
              );
              this.selectedDU.departments.splice(index, 1, res.data);
              this.$bvModal.hide("department-modal");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("department/CreateDepartment", this.department)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.selectedDU.departments.push(res.data);
              this.$bvModal.hide("department-modal");
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    onResetDepartment(row) {
      this.department = {
        id: 0,
        departmentName: "",
        shortName: "",
        deliveryUnitId: row.id,
      };
    },
    updateDepartment(props, row) {
      this.selectedDU = row;
      this.department = cloneDeep(props);
      this.modalTitle = "Update Department";
      this.$bvModal.show("department-modal");
    },
    deleteDepartment(props, row) {
      let index = row.departments.findIndex((item) => item.id == props.id);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("department/DeleteDepartment", props.id)
            .then((res) => {
              if (res.status == 204) {
                row.departments.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              } else {
                this.showToast("Something went wrong!", "error");
              }
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    transferOffice(props, row) {
      this.transfer.type = 1;
      this.selectedChild = props;
      this.selectedParent = row;
      this.modalTitle = `Transfer Office to Another ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`;
      this.$bvModal.show("transfer-modal");
    },
    transferDU(props, row) {
      this.transfer.type = 2;
      this.selectedChild = props;
      this.selectedParent = row;
      this.modalTitle = "Transfer Delivery Unit to Another Office";
      this.$bvModal.show("transfer-modal");
    },
    transferDepartment(props, row) {
      this.transfer.type = 3;
      this.selectedChild = props;
      this.selectedParent = row;
      this.modalTitle = "Transfer Department to Another Delivery Unit";
      this.$bvModal.show("transfer-modal");
    },
    submitTransfer() {
      if (this.transfer.type == 1) {
        if (this.transfer.campusId == this.selectedChild.campusId) {
          return this.showToast("Please select another campus!", "error");
        }
        let data = cloneDeep(this.selectedChild);
        data.campusId = this.transfer.campusId;
        this.$store
          .dispatch("office/UpdateOffice", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.selectedParent.offices.findIndex(
              (item) => item.id == this.selectedChild.id
            );
            this.selectedParent.offices.splice(index, 1);
            this.$bvModal.hide("transfer-modal");
            this.showToast("Successfully transferred!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else if (this.transfer.type == 2) {
        if (this.transfer.officeId == this.selectedChild.officeId) {
          return this.showToast("Please select another office!", "error");
        }
        let data = cloneDeep(this.selectedChild);
        data.officeId = this.transfer.officeId;
        this.$store
          .dispatch("deliveryunit/UpdateDeliveryUnit", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.selectedParent.dus.findIndex(
              (item) => item.id == this.selectedChild.id
            );
            this.selectedParent.dus.splice(index, 1);
            this.$bvModal.hide("transfer-modal");
            this.showToast("Successfully transferred!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else if (this.transfer.type == 3) {
        if (this.transfer.duId == this.selectedChild.deliveryUnitId) {
          return this.showToast(
            "Please select another delivery unit!",
            "error"
          );
        }
        let data = cloneDeep(this.selectedChild);
        data.deliveryUnitId = this.transfer.duId;
        this.$store
          .dispatch("department/UpdateDepartment", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.selectedParent.departments.findIndex(
              (item) => item.id == this.selectedChild.id
            );
            this.selectedParent.departments.splice(index, 1);
            this.$bvModal.hide("transfer-modal");
            this.showToast("Successfully transferred!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    selectInspectionHead() {
      this.employeeSelection = "inspection";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    selectSupplySignatory() {
      this.employeeSelection = "supply";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    selectPropertySignatory() {
      this.employeeSelection = "property";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    selectInventoryPreparedBy() {
      this.employeeSelection = "inventoryPreparedBy";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    selectInventoryReviewedBy() {
      this.employeeSelection = "inventoryReviewedBy";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    dropSingleEmployee(employee) {
      if (this.employeeSelection === "inspection") {
        this.form.inspectionHeadId = employee.applicationUser.id;
        this.form.inspectionHeadName = employee.applicationUser.completeName;
      } else if(this.employeeSelection === "supply") {
        this.form.supplySignatoryId = employee.applicationUser.id;
        this.form.supplySignatory = employee.applicationUser;
      } else if(this.employeeSelection === "opcr"){
        this.form.opcrReviewedBy = employee.applicationUser.completeName;
      } else if(this.employeeSelection === "inventoryPreparedBy") {
        this.form.inventoryPreparedBySignatory = employee.applicationUser.completeName;
        this.form.inventoryPreparedBySignatoryPosition = employee.position;
      } else if(this.employeeSelection === "inventoryReviewedBy") {
        this.form.inventoryReviewedBySignatory = employee.applicationUser.completeName;
        this.form.inventoryReviewedBySignatoryPosition = employee.position;
      } else {
        this.form.propertyCustodianId = employee.applicationUser.id;
        this.form.propertyCustodian = employee.applicationUser;
      }
    },
    clearSelectionInventoryPreparedBy() {
      this.form.inventoryPreparedById = null;
      this.form.inventoryPreparedBy = {completeName: ""};
    },
    clearSelectionInventoryReviewedBy() {
      this.form.inventoryReviewedById = null;
      this.form.inventoryReviewedBy = {completeName: ""};
    },
    clearSelectionInspection() {
      this.form.inspectionHeadId = null;
      this.form.inspectionHeadName = "";
    },
    clearSelectionSupply() {
      this.form.supplySignatoryId = null;
      this.form.supplySignatory = {completeName: ""};
    },
    clearPropertyCustodian() {
      this.form.propertyCustodianId = null;
      this.form.propertyCustodian = {completeName: ""};
    },
    selectOPCRReviewer() {
      this.employeeSelection = "opcr";
      this.$refs.empModal.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    clearOPCRReviewer() {
      this.form.opcrReviewedBy = "";
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-modal
      id="office-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onCreateOffice"
        class="needs-validation"
        ref="fcForm"
      >
        <div class="mb-3">
          <label for="name">Name </label>
          <input
            autocomplete="off"
            id="name"
            type="text"
            v-model="office.name"
            placeholder="Enter Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.office.name.$error,
            }"
          />
          <div
            v-if="submitted && $v.office.name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.office.name.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="shortName">Short Name </label>
          <input
            autocomplete="off"
            id="shortName"
            type="text"
            v-model="office.shortName"
            placeholder="Enter Short Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.office.shortName.$error,
            }"
          />
          <div
            v-if="submitted && $v.office.shortName.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.office.shortName.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="bg-secondary text-center py-2 text-white">
          <!-- Recommending Approval (Sub) -->
          Recommending Approval (Main)
        </div>
        <div class="px-2 border border-secondary border-top-0 pt-2">
          <div class="mb-3">
            <label for="office-signatory">Personnel </label>
            <input
              autocomplete="off"
              id="office-signatory"
              type="text"
              v-model="office.signatory"
              placeholder="Enter personnel..."
              class="form-control"
            />
          </div>
          <div class="mb-3">
            <label for="office-position">Position </label>
            <input
              autocomplete="off"
              id="office-position"
              type="text"
              v-model="office.position"
              placeholder="Enter Position..."
              class="form-control"
            />
          </div>
        </div>
        <div class="bg-gradient-warning text-center py-2 text-white mt-2">
          <!-- Recommending Approval (Sub) -->
          PR Funds Available Signatory
        </div>
        <div class="px-2 border border-secondary border-top-0 pt-2">
          <div class="mb-3">
            <label for="office-signatory">Personnel </label>
            <input
              autocomplete="off"
              id="office-signatory"
              type="text"
              v-model="office.prFundsAvailableSignatory"
              placeholder="Enter personnel..."
              class="form-control"
            />
          </div>
          <div class="mb-3">
            <label for="office-position">Position </label>
            <input
              autocomplete="off"
              id="office-position"
              type="text"
              v-model="office.prFundsAvailablePosition"
              placeholder="Enter Position..."
              class="form-control"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('office-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="du-modal"
      :title="modalTitle"
      size="xl"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form @submit.prevent="onCreateDU" class="needs-validation" ref="fcForm">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="name">Name </label>
              <input
                autocomplete="off"
                id="name"
                type="text"
                v-model="du.name"
                placeholder="Enter Name..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.du.name.$error,
                }"
              />
              <div
                v-if="submitted && $v.du.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.du.name.required">This value is required.</span>
              </div>
            </div>
            <div class="mb-3">
              <label for="shortName">Short Name </label>
              <input
                autocomplete="off"
                id="shortName"
                type="text"
                v-model="du.shortName"
                placeholder="Enter Short Name..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.du.shortName.$error,
                }"
              />
              <div
                v-if="submitted && $v.du.shortName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.du.shortName.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="shortName">Cluster </label>
              <b-form-select
                class="form-select"
                v-model="du.clusterId"
                :options="clusters"
              >
                <!-- <b-form-select-option></b-form-select-option>
                <b-form-select-option v-for="cluster in clusters" :key="cluster.id" :value="cluster.id"
                  >{{ cluster.clusterName }}</b-form-select-option
                > -->
              </b-form-select>
            </div>
            <div
              class="form-check form-checkbox-outline form-check-success mb-3"
            >
              <input
                type="checkbox"
                :id="`hideCampus`"
                checked="checked"
                class="form-check-input"
                v-model="du.hideCampusSignatory"
              /><label :for="`hideCampus`" class="form-check-label">
                <h5 class="text-dark mb-0">
                  Hide Recommending Approval (Main)
                </h5>
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="bg-gradient-warning text-center py-2 text-white">
              Responsibility Center
            </div>
            <div class="px-2 border border-warning border-top-0 pt-2">
              <div class="mb-3">
                <label for="du-rcCodeGf">GF </label>
                <input
                  autocomplete="off"
                  id="du-rcCodeGf"
                  type="text"
                  v-model="du.rcCodeGf"
                  placeholder="Enter GF..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="du-rcCodeStf">STF </label>
                <input
                  autocomplete="off"
                  id="du-rcCodeStf"
                  type="text"
                  v-model="du.rcCodeStf"
                  placeholder="Enter STF..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <div class="bg-secondary text-center py-2 text-white">
              Signatory 1
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="du-signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="du-signatory"
                  type="text"
                  v-model="du.signatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="du-position">Position </label>
                <input
                  autocomplete="off"
                  id="du-position"
                  type="text"
                  v-model="du.position"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="bg-secondary text-center py-2 text-white">
              Dynamic Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2">
              <div class="mb-3">
                <label for="name">Recommending Label </label>
                <input
                  autocomplete="off"
                  id="name"
                  type="text"
                  v-model="du.recommendingLabel"
                  placeholder="Enter Name..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="du-signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="du-signatory"
                  type="text"
                  v-model="du.recommendingSignatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="du-position">Position </label>
                <input
                  autocomplete="off"
                  id="du-position"
                  type="text"
                  v-model="du.recommendingPosition"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('du-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="department-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onCreateDepartment"
        class="needs-validation"
        ref="fcForm"
      >
        <div class="mb-3">
          <label for="name">Name </label>
          <input
            autocomplete="off"
            id="name"
            type="text"
            v-model="department.departmentName"
            placeholder="Enter Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.department.departmentName.$error,
            }"
          />
          <div
            v-if="submitted && $v.department.departmentName.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.department.departmentName.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="shortName">Short Name </label>
          <input
            autocomplete="off"
            id="shortName"
            type="text"
            v-model="department.shortName"
            placeholder="Enter Short Name..."
            class="form-control"
          />
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('department-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="modal-standard"
      :title="modalTitle"
      size="xxl"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <label for="campusName">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} Name </label>
              <input
                autocomplete="off"
                id="campusName"
                type="text"
                v-model="form.campusName"
                :placeholder="`Enter ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} Name...`"
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.campusName.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.campusName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.campusName.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="shortName">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} Short Name </label>
              <input
                autocomplete="off"
                id="shortName"
                type="text"
                v-model="form.shortName"
                :placeholder="`Enter ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} Short Name...`"
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.shortName.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.shortName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.shortName.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="region">Region </label>
              <multiselect
                v-model="region"
                :options="regionSelection"
                label="name"
                id="region"
                @select="getProvince"
              ></multiselect>
              <!-- :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.region.$error,
                            }" -->
              <!-- <div
                                v-if="
                                    submitted &&
                                    $v.form.region.$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="!$v.form.region.required"
                                    >This value is required.</span
                                >
                            </div> -->
            </div>
            <div class="mb-3">
              <label for="province">Province </label>
              <multiselect
                v-model="province"
                :options="provinceSelection"
                label="name"
                @select="getCity"
                id="province"
              ></multiselect>
              <!-- :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.province.$error,
                            }"
                            <div
                                v-if="
                                    submitted &&
                                    $v.form.province.$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="
                                        !$v.form.province.required
                                    "
                                    >This value is required.</span
                                >
                            </div> -->
            </div>
            <div class="mb-3">
              <label for="city">City </label>
              <multiselect
                v-model="city"
                :options="citySelection"
                label="name"
                id="city"
                @select="getBarangays"
              ></multiselect>
              <!-- :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.city.$error,
                            }"
                            <div
                                v-if="
                                    submitted && $v.form.city.$error
                                "
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.city.required"
                                    >This value is required.</span
                                >
                            </div> -->
            </div>
            <div class="mb-3">
              <label for="barangay">Barangay </label>
              <multiselect
                v-model="barangay"
                :options="barangaySelection"
                label="name"
                id="barangay"
                @select="getName"
              ></multiselect>
              <!-- :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.barangay.$error,
                            }"
                            <div
                                v-if="
                                    submitted &&
                                    $v.form.barangay.$error
                                "
                                class="invalid-feedback"
                            >
                                <span
                                    v-if="
                                        !$v.form.barangay.required
                                    "
                                    >This value is required.</span
                                >
                            </div> -->
            </div>
            <div class="mb-3">
              <label for="distric">Congressional District </label>
              <input
                autocomplete="off"
                id="district"
                type="text"
                v-model="form.district"
                placeholder="Enter District..."
                class="form-control"
              />
              <!-- <select id="district" class="form-select" v-model="form.district">
                <option></option>
                <option>LONE</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
              </select> -->
            </div>
            <div class="mb-3">
              <label for="zipcode">Zipcode </label>
              <input
                autocomplete="off"
                id="zipcode"
                type="text"
                v-model="form.zipcode"
                placeholder="Enter Zipcode..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.zipcode.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.zipcode.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.zipcode.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="rfqCode">RFQ Code </label>
              <input
                autocomplete="off"
                id="rfqCode"
                type="text"
                v-model="form.rfqCode"
                placeholder="Enter RFQ Code..."
                class="form-control"
              />
            </div>
            <div class="mb-3">
              <input
                autocomplete="off"
                class="form-check-input"
                type="checkbox"
                id="isExternal"
                v-model="form.isExternal"
              />&nbsp;&nbsp;
              <label class="form-check-label" for="isExternal"
                >Is External?</label
              >
            </div>
            <div class="mb-3">
              <input
                autocomplete="off"
                class="form-check-input"
                type="checkbox"
                id="useAllowPr"
                v-model="form.useAllowPr"
              />&nbsp;&nbsp;
              <label class="form-check-label" for="useAllowPr"
                >Can use Allow PR?</label
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-secondary text-center py-2 text-white position-relative">
              <!-- Recommending Approval (Main) -->
              {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} Signatory
              <!-- <div class="position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%)">
                <a
                  href="javascript:void(0)"
                  class="text-white d-flex align-items-center justify-content-center font-weight-bolder font-size-20"
                  @click="form.hideCampusSignatory = !form.hideCampusSignatory"
                  >
                  <i 
                    class="mdi" 
                    :class="{'mdi-eye': !form.hideCampusSignatory, 'mdi-eye-off': form.hideCampusSignatory}"
                  ></i>
                </a>
              </div> -->
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.signatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="position">Position </label>
                <input
                  autocomplete="off"
                  id="position"
                  type="text"
                  v-model="form.position"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              Funds Available Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.fundsAvailableSignatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="position">Position </label>
                <input
                  autocomplete="off"
                  id="position"
                  type="text"
                  v-model="form.fundsAvailablePosition"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              Procurement Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.procurementSignatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="position">Position </label>
                <input
                  autocomplete="off"
                  id="position"
                  type="text"
                  v-model="form.procurementSignatoryPosition"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              COA Email
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">Email </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.coaEmail"
                  placeholder="Enter email..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              BAC Website/Public Bidding Address
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">BAC Website </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.bacWebsite"
                  placeholder="Enter website..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="signatory">Public Bidding Address </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.publicBiddingAddress"
                  placeholder="Enter Bidding Address..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-secondary text-center py-2 text-white">
              Inspection Head
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Inspection Head
                  </label>
                  <a
                    href="javascript:void(0)"
                    class="text-danger d-flex align-items-center justify-content-center font-weight-bolder"
                    @click="clearSelectionInspection"
                    ><i class="bx bx-x"></i>Clear Selection</a
                  >
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectInspectionHead"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.inspectionHeadName"
                    placeholder="Select signatory..."
                    class="form-control"
                    disabled
                  />
                </b-input-group>
              </div>
              <div class="mb-3">
                <label for="signatory">Inspection Head Number</label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.inspectionContactNumber"
                  placeholder="Contact Number..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              Supply Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Supply Signatory
                  </label>
                  <a
                    href="javascript:void(0)"
                    class="text-danger d-flex align-items-center justify-content-center font-weight-bolder"
                    @click="clearSelectionSupply"
                    ><i class="bx bx-x"></i>Clear Selection</a
                  >
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectSupplySignatory"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.supplySignatory.completeName"
                    placeholder="Select signatory..."
                    class="form-control"
                    disabled
                  />
                </b-input-group>
              </div>
              <div class="mb-3">
                <label for="signatory">Signatory Position</label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.supplySignatoryPosition"
                  placeholder="Signatory Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              PR Funds Available Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <label for="signatory">Personnel </label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.prFundsAvailableSignatory"
                  placeholder="Enter signatory..."
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="position">Position </label>
                <input
                  autocomplete="off"
                  id="position"
                  type="text"
                  v-model="form.prFundsAvailablePosition"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              Property Custodian
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Personnel
                  </label>
                  <a
                    href="javascript:void(0)"
                    class="text-danger d-flex align-items-center justify-content-center font-weight-bolder"
                    @click="clearPropertyCustodian"
                    ><i class="bx bx-x"></i>Clear Selection</a
                  >
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectPropertySignatory"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.propertyCustodian.completeName"
                    placeholder="Enter signatory..."
                    class="form-control"
                  />
                </b-input-group>
              </div>
              <div class="mb-3">
                <label for="position">Position </label>
                <input
                  autocomplete="off"
                  id="position"
                  type="text"
                  v-model="form.propertyCustodianPosition"
                  placeholder="Enter Position..."
                  class="form-control"
                />
              </div>
            </div>
            <div class="bg-secondary text-center py-2 text-white">
              OPCR Reviewer
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-3">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Personnel
                  </label>
                  <a
                    href="javascript:void(0)"
                    class="text-danger d-flex align-items-center justify-content-center font-weight-bolder"
                    @click="clearOPCRReviewer"
                    ><i class="bx bx-x"></i>Clear Selection</a
                  >
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectOPCRReviewer"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.opcrReviewedBy"
                    placeholder="Enter signatory..."
                    class="form-control"
                  />
                </b-input-group>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-secondary text-center py-2 text-white">
              Inventory Signatory
            </div>
            <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
              <div class="mb-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Prepared By
                  </label>
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectInventoryPreparedBy"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.inventoryPreparedBySignatory"
                    placeholder="Select signatory..."
                    class="form-control"
                    disabled
                  />
                </b-input-group>
              </div>
              <div class="mb-3">
                <label for="signatory">Prepared By Position</label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.inventoryPreparedBySignatoryPosition"
                  placeholder="Enter Prepared By Position..."
                  class="form-control"
                />
              </div>
              <div class="mb-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <label for="signatory" class="text-nowrap mb-0"
                    >Reviewed By
                  </label>
                </div>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectInventoryReviewedBy"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.inventoryReviewedBySignatory"
                    placeholder="Select signatory..."
                    class="form-control"
                    disabled
                  />
                </b-input-group>
              </div>
              <div class="mb-3">
                <label for="signatory">Reviewed By Position</label>
                <input
                  autocomplete="off"
                  id="signatory"
                  type="text"
                  v-model="form.inventoryReviewedBySignatoryPosition"
                  placeholder="Enter Reviewed By Position..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button type="button" class="btn btn-link" @click="hideModal">
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="transfer-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form @submit.prevent="submitTransfer">
        <div class="mb-3">
          <label for="campus">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
          <select
            id="campus"
            v-model="transfer.campusId"
            class="form-select"
            @change="getOffices(transfer.campusId, true)"
          >
            <option></option>
            <option
              v-for="campus in tableData"
              :value="campus.id"
              :key="campus.id"
            >
              {{ campus.campusName }}
            </option>
          </select>
        </div>
        <div class="mb-3" v-if="transfer.type > 1">
          <label for="campus">Office </label>
          <select
            id="campus"
            v-model="transfer.officeId"
            class="form-select"
            @change="getDUs(transfer.officeId, true)"
          >
            <option></option>
            <option
              v-for="office in offices"
              :value="office.id"
              :key="office.id"
            >
              {{ office.name }}
            </option>
          </select>
        </div>
        <div class="mb-3" v-if="transfer.type > 2">
          <label for="campus">Delivery Unit </label>
          <select id="campus" v-model="transfer.duId" class="form-select">
            <option></option>
            <option v-for="du in dus" :value="du.id" :key="du.id">
              {{ du.name }}
            </option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('transfer-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <div class="row">
      <div class="col-12">
        <div class="card border">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4 class="card-title m-0">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} List</h4>
              </div>
              <button
                type="button"
                @click="addCampus()"
                class="btn btn-md btn-info d-flex align-items-center"
              >
                <i class="bx bx-plus fs-6"></i>Create New
              </button>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
              >
                <template #empty="scope">
                  <div class="text-center">
                    {{ scope.emptyText }}
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div class="float-end">
                    <b-dropdown
                      id="dropdown-dropleft"
                      right
                      variant="link"
                      toggle-class="text-decoration-none"
                      menu-class="dropdown-menu-end"
                      no-caret
                    >
                      <template #button-content>
                        <i class="fas fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item
                        @click="showDtls(row)"
                        variant="secondary"
                        ><i class="mdi mdi-view-list font-size-18 me-1"></i>View
                        Offices</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="updateItem(row)"
                        variant="secondary"
                        ><i class="mdi mdi-update font-size-18 me-1"></i
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item @click="deleteItem(row)" variant="danger"
                        ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                        >Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </template>
                <template #cell(item)="row">
                  <div
                    class="d-flex align-items-center justify-content-center"
                    @click="showDtls(row)"
                  >
                    <i
                      class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                      :class="{
                        'rotate-90': row.item.rotateChevy,
                      }"
                    ></i>
                  </div>
                </template>
                <template #row-details="row">
                  <div class="card">
                    <div
                      class="card-header d-flex align-items-center justify-content-between"
                    >
                      <h5 class="card-title mb-0">List of Offices</h5>
                      <div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addOffice(row.item)"
                        >
                          <i class="bx bx-plus me-1"></i>Add New Office
                        </button>
                      </div>
                    </div>
                    <div class="card-body px-3 py-2">
                      <div v-for="x in row.item.offices" :key="x.id">
                        <div class="d-flex align-items-center hover-toggle">
                          <div
                            class="font-size-15 cursor-pointer d-flex align-items-center text-info"
                            @click="getDUs(x)"
                          >
                            <i
                              class="bx bx-chevron-right me-1 rotate"
                              :class="{
                                'rotate-90': x.showDtls,
                              }"
                            ></i
                            >{{ x.name }}
                          </div>
                          <div class="zed-10 ms-1 hover-content">
                            <a
                              href="javascript:void(0);"
                              title="Add New Delivery Unit"
                              @click="addDU(x)"
                              ><i class="mdi mdi-plus text-success"></i
                            ></a>
                            <a
                              href="javascript:void(0);"
                              title="Edit"
                              @click="updateOffice(x, row.item)"
                              ><i class="mdi mdi-content-save-edit"></i
                            ></a>
                            <a
                              href="javascript:void(0);"
                              title="Delete"
                              @click="deleteOffice(x, row.item)"
                              ><i class="mdi mdi-trash-can text-danger"></i
                            ></a>
                            <a
                              href="javascript:void(0);"
                              title="Transfer"
                              @click="transferOffice(x, row.item)"
                              ><i class="mdi mdi-transfer-up text-info"></i
                            ></a>
                          </div>
                        </div>
                        <div v-if="x.showDtls">
                          <div
                            v-for="y in x.dus"
                            :key="`X${x.id}Y${y.id}`"
                            class="ms-3"
                          >
                            <div class="d-flex align-items-center hover-toggle">
                              <div
                                class="font-size-14 cursor-pointer d-flex align-items-center text-warning"
                                @click="getDepartments(y)"
                              >
                                <i
                                  class="bx bx-chevron-right me-1 rotate"
                                  :class="{
                                    'rotate-90': y.showDtls,
                                  }"
                                ></i
                                >({{ y.id }}) {{ y.name }}
                              </div>
                              <div class="zed-10 ms-1 hover-content">
                                <a
                                  href="javascript:void(0);"
                                  title="Add New Department"
                                  @click="addDepartment(y)"
                                  ><i class="mdi mdi-plus text-success"></i
                                ></a>
                                <a
                                  href="javascript:void(0);"
                                  title="Edit"
                                  @click="updateDU(y, x)"
                                  ><i class="mdi mdi-content-save-edit"></i
                                ></a>
                                <a
                                  href="javascript:void(0);"
                                  title="Delete"
                                  @click="deleteDU(y, x)"
                                  ><i class="mdi mdi-trash-can text-danger"></i
                                ></a>
                                <a
                                  href="javascript:void(0);"
                                  title="Transfer"
                                  @click="transferDU(y, x)"
                                  ><i class="mdi mdi-transfer-up text-info"></i
                                ></a>
                              </div>
                            </div>

                            <div class="d-flex ms-5">
                              <div :class="{ 'text-white': !y.rcCodeGf }">
                                GF: {{ y.rcCodeGf ? y.rcCodeGf : "No RCC yet" }}
                              </div>
                              <div class="mx-3">|</div>
                              <div :class="{ 'text-white': !y.rcCodeStf }">
                                STF:
                                {{ y.rcCodeStf ? y.rcCodeStf : "No RCC yet" }}
                              </div>
                            </div>
                            <div v-if="y.showDtls">
                              <div
                                v-for="z in y.departments"
                                :key="`X${x.id}Y${y.id}Z${z.id}`"
                                class="ms-4"
                              >
                                <div
                                  class="d-flex align-items-center hover-toggle"
                                >
                                  <div
                                    class="font-size-12 d-flex align-items-center"
                                  >
                                    ({{ z.id }}) {{ z.departmentName }}
                                  </div>
                                  <div class="zed-10 ms-1 hover-content">
                                    <a
                                      href="javascript:void(0);"
                                      title="Edit"
                                      @click="updateDepartment(z, y)"
                                      ><i class="mdi mdi-content-save-edit"></i
                                    ></a>
                                    <a
                                      href="javascript:void(0);"
                                      title="Delete"
                                      @click="deleteDepartment(z, y)"
                                      ><i
                                        class="mdi mdi-trash-can text-danger"
                                      ></i
                                    ></a>
                                    <a
                                      href="javascript:void(0);"
                                      title="Transfer"
                                      @click="transferDepartment(z, y)"
                                      ><i
                                        class="mdi mdi-transfer-up text-info"
                                      ></i
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <employee-modal
      ref="empModal"
      @dropData="dropSingleEmployee"
    ></employee-modal>
  </Layout>
</template>